const indexItems = [
  { title: '热血战斗', count: '326部', icon: 'ri-sword-line', color: 'text-primary-500', bg: 'bg-primary-100' },
  { title: '甜蜜恋爱', count: '218部', icon: 'ri-heart-line', color: 'text-primary-500', bg: 'bg-primary-100' },
  { title: '玄幻修仙', count: '287部', icon: 'ri-moon-line', color: 'text-accent-500', bg: 'bg-accent-100' },
  { title: '悬疑推理', count: '154部', icon: 'ri-search-eye-line', color: 'text-accent-500', bg: 'bg-accent-100' },
  { title: '搞笑日常', count: '193部', icon: 'ri-emotion-laugh-line', color: 'text-accent-500', bg: 'bg-accent-100' },
  { title: '科幻未来', count: '142部', icon: 'ri-rocket-line', color: 'text-secondary-500', bg: 'bg-secondary-100' },
  { title: '恐怖惊悚', count: '98部', icon: 'ri-ghost-line', color: 'text-secondary-500', bg: 'bg-secondary-100' },
  { title: '运动竞技', count: '87部', icon: 'ri-basketball-line', color: 'text-secondary-500', bg: 'bg-secondary-100' },
];

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">主题分类</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            八大主题分类，精准定位你喜欢的漫画类型，快速发现心仪作品
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 max-w-4xl mx-auto">
          {indexItems.map((item) => (
            <a
              key={item.title}
              href="#"
              className="flex flex-col items-center gap-3 p-5 rounded-xl border border-background-200/70 hover:border-primary-200 hover:bg-background-100 transition-all duration-300 cursor-pointer no-underline"
            >
              <div className={`w-12 h-12 flex items-center justify-center rounded-xl ${item.bg}`}>
                <i className={`${item.icon} text-xl ${item.color}`}></i>
              </div>
              <div className="text-center">
                <div className="text-sm font-medium text-foreground-950 whitespace-nowrap">{item.title}</div>
                <div className="text-xs text-foreground-400 mt-0.5">{item.count}</div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}